<!--login-->
<template>
  <div class="login-box fs18">
    <div class="left-box">
      <img :src="`编组76.png` | fullImageUrl" alt="" />
    </div>
    <div class="main-bar-bar">
      <img class="img-one" :src="login_logo" alt="" />
      <div class="main-bar">
        <div class="left-box-bg">
          <img class="img-two" :src="renwuBg" alt="" />
        </div>

        <div class="right-box">
          <div class="login-form">
            <img class="login-img" :src="login_logo" alt="logo">

            <div class="flex title-box cr mt10 mb10">
              <div
                class="login-pp"
                :class="loginState == 1 ? 'pp-active' : ''"
                @click="changeLogin(1)"
              >
                登录/
              </div>
              <div
                class="login-pp"
                :class="loginState == 2 ? 'pp-active' : ''"
                @click="changeLogin(2)"
              >
                兑换码激活注册
              </div>
            </div>

            <div v-if="loginState == 1">
              <div class="login1 mt15 mb15">
                <el-input placeholder="请输入手机号" v-model="username">
                  <template #prefix>
                    <div class="login-input-prefix">
                      <img :src="`编组59.png` | fullImageUrl" />
                    </div>
                  </template>
                </el-input>
              </div>
              <div class="login2 mb15">
                <el-input
                  placeholder="请输入密码"
                  v-model="password"
                  show-password
                  @keyup.enter.native="handleLogin"
                >
                  <template #prefix>
                    <div class="login-input-prefix">
                      <img :src="`编组60.png` | fullImageUrl" />
                    </div>
                  </template>
                </el-input>
              </div>
            </div>

            <div v-if="loginState == 2">
              <div class="login1 mt15 mb15">
                <el-input placeholder="请输入手机号" v-model="username2">
                  <template #prefix>
                    <div class="login-input-prefix">
                      <img :src="`编组59.png` | fullImageUrl" />
                    </div>
                  </template>
                </el-input>
              </div>
              <div class="login2 mb15">
                <el-input
                  placeholder="请输入密码"
                  v-model="password2"
                  show-password
                >
                  <template #prefix>
                    <div class="login-input-prefix">
                      <img :src="`编组60.png` | fullImageUrl" />
                    </div>
                  </template>
                </el-input>
              </div>
              <div class="login2 mt15 mb15">
                <el-input placeholder="算力兑换码" v-model="code">
                  <template #prefix>
                    <div class="login-input-prefix">
                      <img :src="`编组61.png` | fullImageUrl" />
                    </div>
                  </template>
                </el-input>
              </div>
            </div>

            <div
              v-if="loginState == 1"
              class="loginbottom"
              style="width: 100%; margin-top: 10px"
              @click="handleLogin"
            >
              登录
            </div>
            <div
              v-else
              class="loginbottom"
              style="width: 100%; margin-top: 10px"
              @click="handleSign"
            >
              兑换码激活注册
            </div>
            <div class="flex ac mt20 fs14 privacy">
              <el-checkbox v-model="checked" :text-color="red"
              >我已阅读并同意</el-checkbox
              >
              <div style="color: #c0c4cc" v-if="eula && privacy_agreement">
                <a
                  style="color: #f7d274; cursor: pointer"
                  :href="eula"
                  target="_blank"
                  rel="noreferrer"
                >《用户协议》</a
                >与
                <a
                  style="color: #f7d274; cursor: pointer"
                  :href="privacy_agreement"
                  target="_blank"
                  rel="noreferrer"
                >《隐私条款》</a
                >
              </div>
              <div v-else style="color: #c0c4cc">
                <span
                  style="color: #f7d274; cursor: pointer"
                  @click="goProtocol('user')"
                >《用户协议》</span
                >与
                <span
                  style="color: #f7d274; cursor: pointer"
                  @click="goProtocol('privacy')"
                >《隐私条款》</span
                >
              </div>
            </div>
            <div class="icp-box" v-if="beian">
              <a
                href="https://beian.miit.gov.cn"
                target="_blank"
                rel="noreferrer"
              >ICP备案号:{{ beian }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import imgVerifyCom from "../components/MyImgVerify"; //导入子组件
  import { employeeLogin, site, cdkey } from "../api/user";

  export default {
    name: "",
    components: { imgVerifyCom }, //注册子组件
    data() {
      return {
        txText: "",
        username: "",
        password: "",
        login_bg: "",
        login_logo: "",
        login_title: "",
        checked: false,
        beian: "粤ICP备2024308983号-1",
        privacy_agreement: "",
        eula: "",
        loginState: 1,
        username2: "",
        password2: "",
        code: "",
        renwuBg: ''
      };
    },
    created() {
      this.loginState = this.$route.query.state ? this.$route.query.state : 1;
      this.getSite();
      //   this.$refs.verifyRef.imgCode
    },
    methods: {
      changeLogin(val) {
        this.loginState = val;
      },
      handleLogin() {
        if (!this.checked) {
          this.$message.error("请阅读并同意<<用户协议>>与<<隐私条款>>");
          return false;
        }
        if (!this.username || !this.password) {
          this.$message.error("请输入手机号密码");
          return false;
        }
        employeeLogin({
          username: this.username,
          password: this.password,
          client: "pc",
        })
          .then((res) => {
            if (res && res.data.token) {
              this.$message.success("登录成功");
              window.localStorage.setItem("xcToken", res.data.token);
              if (this.redirectUrl) {
                setTimeout(() => {
                  this.$router.replace({
                    path: this.redirectUrl,
                  });
                }, 800);
              } else {
                localStorage.setItem("navId", 0);
                setTimeout(() => {
                  this.$router.push({
                    path: "/",
                  });
                }, 800);
              }
            }
          })
          .catch((error) => {
            this.$message.error(error.msg);
          });
      },
      // 激活码注册
      handleSign() {
        if (!this.checked) {
          this.$message.error("请阅读并同意<<用户协议>>与<<隐私条款>>");
          return false;
        }
        if (!this.username2 || !this.password2) {
          this.$message.error("请输入手机号密码");
          return false;
        }
        if (!this.code) {
          this.$message.error("请输入算力兑换码");
          return false;
        }
        cdkey({
          code: this.code,
          username: this.username2,
          password: this.password2,
          client: "pc",
        })
          .then((res) => {
            console.log("2222", res);
            this.$message.success(
              "您已成功兑换" + res.data.credits + "积分并注册成功"
            );
            window.localStorage.setItem("xcToken", res.data.token);
            if (this.redirectUrl) {
              setTimeout(() => {
                this.$router.replace({
                  path: this.redirectUrl,
                });
              }, 800);
            } else {
              localStorage.setItem("navId", 0);
              setTimeout(() => {
                this.$router.push({
                  path: "/",
                });
              }, 800);
            }
          })
          .catch((error) => {
            // this.$message.error(error.msg);
          });
      },
      // 获取配置
      getSite() {
        this.login_bg =
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组1.png";
        site().then((res) => {
          this.beian = res.data.icp;
          this.renwuBg = res.data.login_bg
          // this.login_bg = res.data.login_bg
          //   ? res.data.login_bg
          //   : "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组1.png";
          this.login_logo = res.data.login_logo
          this.login_title = res.data.login_title
            ? res.data.login_title
            : "STARNEST ENGINE";
          this.privacy_agreement = res.data.privacy_agreement;
          this.eula = res.data.eula;
          const logo = res.data.logo;
          if (logo) {
            window.onload = function () {
              var link =
                document.querySelector("link[rel*='icon']") ||
                document.createElement("link");
              link.type = "image/x-icon";
              link.rel = "shortcut icon";
              link.href = logo; // 将这里的地址替换为新的favicon地址
              document.getElementsByTagName("head")[0].appendChild(link);
            };
          }
        });
      },
      changeTitle() {
        site().then((res) => {
          const title = res.data.title;
          if (title) {
            document.title = title;
          }
        });
      },
      goUrl(val) {
        window.open(val);
      },
      goProtocol(val) {
        const routeData = this.$router.resolve({
          path: "/protocol",
          query: {
            type: val,
          },
        });
        window.open(routeData.href, "_blank");
      },
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
      this.changeTitle();
    },
  };
</script>
<style>
  /* 覆盖浏览器自动填充时的背景色 */
  .el-input__inner:-webkit-autofill,
  .el-input__inner:-webkit-autofill:hover,
  .el-input__inner:-webkit-autofill:focus,
  .el-input__inner:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #1f1f1f inset !important;
    -webkit-text-fill-color: #fff !important;
    transition: background-color 5000s ease-in-out 0s;
  }
  .right-box .el-input__inner {
    color: #ffffff;
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
</style>
<style lang="scss" scoped>
  .login-input-prefix {
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
      margin-top: 9px;
    }
  }

  .login-box {
    // width: 100vw;
    height: 100vh;
    // background-color: #191919;
    position: relative;
  }
  .main-bar-bar {
    width: 100vw;
    // height: 100vh;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // align-items: ;

    .img-one {
      // position: absolute;
      // top: 20px;
      // left: 56px;
      // // top: 66px;
      // // right: 0;
      // z-index: 999;
      width: 64px;
      height: 64px;
      margin-left: 56px;
      margin-top: 25px;
    }
  }
  .main-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;

    // left: 30%;
    // right: 0;
    // z-index: 999;
  }

  .left-box-bg {
    .img-two {
      width: 748px;
      height: 863.06px;
    }
  }

  .left-box {
    // width: calc(100% - 700px);
    // width: 100%;
    // width: 180px;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      // object-fit: contain;
    }
  }

  .right-box {
    // position: relative;
    // width: 700px;
    // height: 100vh;
    // position: absolute;
    // top: 0;
    // // left: 0;
    // right: 10%;
    // z-index: 999;
    .login-form {
      width: 512px;
      background-color: #1c1c1f;
      border-radius: 4px;
      padding: 40px 50px;
      .login-img{
        height: 48px;
      }
      .loginbottom {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-content: center;
        width: 100%;
        height: 40px;
        background: linear-gradient(
            135deg,
            #f7d274 0%,
            #f6d686 27%,
            #f5dfb5 100%
        );
        border-radius: 8px;
        font-weight: 500;
        font-size: 16px;
        color: #191919;
        line-height: 42px;
        letter-spacing: 1px;
        text-align: center;
        font-style: normal;
      }
      .login-logo-img1 {
        width: 30px;
        height: 23px;
      }
      .login-logo-img2 {
        width: 85px;
        height: 24px;
      }

      .login-title {
        font-size: 24px;
        font-weight: 700;
        margin: 10px 0;
      }

      .title-box {
        padding-top: 34px;
        padding-bottom: 24px;
        align-items: flex-end;

        .login-pp {
          font-weight: 500;
          font-size: 14px;
          color: #c0c4cc;
        }

        .pp-active {
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
        }
      }

      .icp-box {
        position: absolute;
        bottom: 15px;
        left: 0;
        width: 100%;
        font-size: 12px;
        text-align: center;
        color: #777;
        text-decoration: underline;
      }
    }
    .login2 {
      margin-top: 24px;
    }
    .privacy {
      margin-top: 24px;
      margin-bottom: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue